import { nucleusConstants } from '@lifesize/nucleus';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _memoize from 'lodash/memoize';
import _omitBy from 'lodash/omitBy';
import intl from 'react-intl-universal';
import { ListMeetingsQuery } from '../typings/types';
import MeetingInlineFragment = ListMeetingsQuery.MeetingInlineFragment;

/**
 * Maps GraphQL names to the appropriate API payload names
 * Drop any key/values that are null or undefined (using omitBy)
 * @param formFields
 */
const mapMeetingFieldsToPayloadObject = (formFields: MeetingInlineFragment) => {
  return _omitBy({
    uuid: formFields.uuid,
    meeting_id: _get(formFields, 'meeting_id'),
    contactType: nucleusConstants.CONTACT_TYPE_MEETING,
    name: _get(formFields, 'name'),
    // TODO - change 'description' to typed prop when field avail in schema
    description: _get(formFields, 'description'),
    pin: formFields.pin,
    meetingType: _get(formFields, 'meetingType', nucleusConstants.MEETING_TYPE_VMR),
    hiddenMeeting: false,
    moderatorExtension: _get(formFields.moderator, 'extension'),
    ownerExtension: _get(formFields.owner, 'extension'),
    lecturerExtension: _get(formFields.lecturer, 'extension')
  },             _isNil);
};

const isOneTimeMeeting = _memoize((meetingType: string) => {
  return meetingType ? meetingType.trim().toUpperCase() === nucleusConstants.MEETING_TYPE_ONE_TIME : false;
});

const isPermanentMeeting = (meetingType: string) => {
  return meetingType ? meetingType.trim().toUpperCase() === nucleusConstants.MEETING_TYPE_VMR : false;
};

const getMeetingTypeLabel = _memoize((meetingType: string) => {
  if (meetingType) {
    return isOneTimeMeeting(meetingType) ? intl.get('meetingTypeOneTime') : intl.get('meetingTypePermanent');
  }
  return null;
});

export {
  mapMeetingFieldsToPayloadObject,
  isOneTimeMeeting,
  isPermanentMeeting,
  getMeetingTypeLabel
};
